<template>
  <button
    :type="type"
    @click="$emit('click')"
    class="ui-buttonv2--pill"
    :class="{
      'ui-buttonv2--block': block,
      [`ui-buttonv2--${size}`]: true,
      [`ui-buttonv2--${variant}`]: true,
    }"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    pill: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    size: {
      type: String,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.ui-buttonv2--primary,
.ui-buttonv2--outline-dark,
.ui-buttonv2--outline-primary {
  outline: none;
  cursor: pointer;
  min-width: 80px;
  border: 1px solid;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;

  & > *:last-child { margin-right: 0; }

  &:focus, &:hover, &:active {
    color: $white;
    background-color: $primary-100;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.ui-buttonv2--pill {
  border-radius: 22px;
}

.ui-buttonv2--outline-dark {
  color: $black;
  border-color: $dark-gray;
  background-color: $white;
}

.ui-buttonv2--primary {
  color: $white;
  border-color: $white;
  background-color: $primary-90;
}

.ui-buttonv2--outline-primary {
  color: $primary;
  border-color: $primary;
  background-color: $white;
}

.ui-buttonv2--lg {
  height: 40px;
  font-size: 16px;
  font-weight: bold;
}

.ui-buttonv2--xl {
  height: 48px;
  font-size: 18px;
  font-weight: bold;
}

.ui-buttonv2--block {
  width: 100%;
}
</style>
